/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import * as React from 'react';
import { IExtHtmlBlockViewProps } from './ext-html-block';

const ExtHtmlBlockView: React.FC<IExtHtmlBlockViewProps> = props => (
    <div className={props.className} id={props.id} {...props.renderModuleAttributes(props)}>
        {props.content}
    </div>
);

export default ExtHtmlBlockView;
